function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CSS_VARS, EVENT_TYPE } from './constants';
import { find, addClass, removeClass, getViewportSize, offset } from './helpers/dom';

/**
 * @class Internal
 */
export var Internal = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {Function} base Base class.
   */
  function Internal(base) {
    _classCallCheck(this, Internal);
    /**
     * @type {ol.control.Control}
     */
    this.Base = base;
    /**
     * @type {ol.Map}
     */
    this.map = undefined;
    /**
     * @type {Element}
     */
    this.viewport = undefined;
    /**
     * @type {ol.Coordinate}
     */
    this.coordinateClicked = undefined;
    /**
     * @type {ol.Pixel}
     */
    this.pixelClicked = undefined;
    /**
     * @type {Number}
     */
    this.lineHeight = 0;
    /**
     * @type {Object}
     */
    this.items = {};
    /**
     * @type {Boolean}
     */
    this.opened = false;
    /**
     * @type {Object}
     */
    this.submenu = {
      left: "".concat(base.options.width - 15, "px"),
      lastLeft: '' // string + px
    };
    /**
     * @type {Function}
     */
    this.eventHandler = this.handleEvent.bind(this);
    /**
     * @type {Function}
     */
    this.eventMapMoveHandler = this.handleMapMoveEvent.bind(this);
    return this;
  }
  _createClass(Internal, [{
    key: "init",
    value: function init(map) {
      this.map = map;
      this.viewport = map.getViewport();
      this.setListeners();
      this.Base.Html.createMenu();
      this.lineHeight = this.getItemsLength() > 0 ? this.Base.container.offsetHeight / this.getItemsLength() : this.Base.Html.cloneAndGetLineHeight();
    }
  }, {
    key: "getItemsLength",
    value: function getItemsLength() {
      var _this = this;
      var count = 0;
      Object.keys(this.items).forEach(function (k) {
        if (_this.items[k].submenu || _this.items[k].separator) return;
        count++;
      });
      return count;
    }
  }, {
    key: "getPixelClicked",
    value: function getPixelClicked() {
      return this.pixelClicked;
    }
  }, {
    key: "getCoordinateClicked",
    value: function getCoordinateClicked() {
      return this.coordinateClicked;
    }
  }, {
    key: "positionContainer",
    value: function positionContainer(pixel) {
      var _this2 = this;
      var container = this.Base.container;
      var mapSize = this.map.getSize();
      // how much (width) space left over
      var space_left_h = mapSize[1] - pixel[1];
      // how much (height) space left over
      var space_left_w = mapSize[0] - pixel[0];
      var menuSize = {
        w: container.offsetWidth,
        // a cheap way to recalculate container height
        // since offsetHeight is like cached
        h: Math.round(this.lineHeight * this.getItemsLength())
      };
      // submenus
      var subs = find("li.".concat(CSS_VARS.submenu, ">div"), container, true);
      if (space_left_w >= menuSize.w) {
        container.style.right = 'auto';
        container.style.left = "".concat(pixel[0] + 5, "px");
      } else {
        container.style.left = 'auto';
        container.style.right = '15px';
      }
      // set top or bottom
      if (space_left_h >= menuSize.h) {
        container.style.bottom = 'auto';
        container.style.top = "".concat(pixel[1] - 10, "px");
      } else {
        container.style.top = 'auto';
        container.style.bottom = 0;
      }
      removeClass(container, CSS_VARS.hidden);
      if (subs.length) {
        if (space_left_w < menuSize.w * 2) {
          // no space (at right) for submenu
          // position them at left
          this.submenu.lastLeft = "-".concat(menuSize.w, "px");
        } else {
          this.submenu.lastLeft = this.submenu.left;
        }
        subs.forEach(function (sub) {
          // is there enough space for submenu height?
          var viewport = getViewportSize();
          var sub_offset = offset(sub);
          var sub_height = sub_offset.height;
          var sub_top = space_left_h - sub_height;
          if (sub_top < 0) {
            sub_top = sub_height - (viewport.h - sub_offset.top);
            sub.style.top = "-".concat(sub_top, "px");
          }
          sub.style.left = _this2.submenu.lastLeft;
        });
      }
    }
  }, {
    key: "openMenu",
    value: function openMenu(pixel, coordinate) {
      this.Base.dispatchEvent({
        type: EVENT_TYPE.OPEN,
        pixel: pixel,
        coordinate: coordinate
      });
      this.opened = true;
      this.positionContainer(pixel);
    }
  }, {
    key: "closeMenu",
    value: function closeMenu() {
      this.opened = false;
      addClass(this.Base.container, CSS_VARS.hidden);
      this.Base.dispatchEvent({
        type: EVENT_TYPE.CLOSE
      });
    }
  }, {
    key: "setListeners",
    value: function setListeners() {
      this.viewport.addEventListener(this.Base.options.eventType, this.eventHandler, false);
      this.map.on('movestart', this.eventMapMoveHandler);
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      this.viewport.removeEventListener(this.Base.options.eventType, this.eventHandler, false);
      this.map.un('movestart', this.eventMapMoveHandler);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(evt) {
      var _this3 = this;
      var this_ = this;
      this.coordinateClicked = this.map.getEventCoordinate(evt);
      this.pixelClicked = this.map.getEventPixel(evt);
      this.Base.dispatchEvent({
        type: EVENT_TYPE.BEFOREOPEN,
        pixel: this.pixelClicked,
        coordinate: this.coordinateClicked
      });
      if (this.Base.disabled) return;
      if (this.Base.options.eventType === EVENT_TYPE.CONTEXTMENU) {
        // don't be intrusive with other event types
        evt.stopPropagation();
        evt.preventDefault();
      }
      this.openMenu(this.pixelClicked, this.coordinateClicked);

      //one-time fire
      evt.target.addEventListener('pointerdown', {
        handleEvent: function handleEvent(e) {
          if (this_.opened) {
            this_.closeMenu();
            e.stopPropagation();
            evt.target.removeEventListener(e.type, _this3, false);
          }
        }
      }, false);
    }
  }, {
    key: "handleMapMoveEvent",
    value: function handleMapMoveEvent(_evt) {
      this.closeMenu();
    }
  }, {
    key: "setItemListener",
    value: function setItemListener(li, index) {
      var this_ = this;
      if (li && typeof this.items[index].callback === 'function') {
        (function (callback) {
          li.addEventListener('click', function (evt) {
            evt.preventDefault();
            var obj = {
              coordinate: this_.getCoordinateClicked(),
              data: this_.items[index].data || null
            };
            this_.closeMenu();
            callback(obj, this_.map);
          }, false);
        })(this.items[index].callback);
      }
    }
  }]);
  return Internal;
}();